import { schedulingPublicAvailabilitySchema, schedulingPublicProposalSchema } from "./scheduling.js";
import { schedulingPublicAvailabilityRequestSchema, schedulingPublicClaimRequestSchema, schedulingPublicClaimResponseSchema, schedulingPublicProposalRequestSchema, schedulingPublicReceiptSchema } from "./scheduling-proposal-requests.js";
/** The capability travels only in POST JSON, never in request paths or query strings. */
export const SCHEDULING_GUEST_PATH = /^\/api\/scheduling\/public\/([a-z0-9][a-z0-9_.-]{0,127})\/(proposal|availability|claim|receipt)$/u;
export const SCHEDULING_GUEST_PROTOCOL = {
    proposal: { request: schedulingPublicProposalRequestSchema, response: schedulingPublicProposalSchema },
    availability: { request: schedulingPublicAvailabilityRequestSchema, response: schedulingPublicAvailabilitySchema },
    claim: { request: schedulingPublicClaimRequestSchema, response: schedulingPublicClaimResponseSchema },
    receipt: { request: schedulingPublicProposalRequestSchema, response: schedulingPublicReceiptSchema },
};
export function schedulingGuestRoute(pathname) {
    const match = SCHEDULING_GUEST_PATH.exec(pathname);
    return match ? { tenantSlug: match[1], action: match[2] } : null;
}
